<!--
 * @Author: your name
 * @Date: 2022-05-30 13
-->
<template>
  <div class="dynamic-row" >
    <div class="bast-dynamic-detail">
      <div class="bast-dynamic-detail-box">
        <div v-for="(item,idx) in dynamicList" :key="idx" class="bast-dynamic-detail-item animate__animated animate__slow" :class="idx%3==0 ? 'animate__fadeInLeft' : (idx-1)%3==0 ? 'animate__fadeInUp upkeep-content-margin' : (idx-2)%3==0 ? 'animate__fadeInRight':''" @click="topath(idx,item)">
          <div class="item-box">
            <div class="img-box">
              <img :src="item.preview" alt="" class="bast-dynamic-detail-img">
            </div>
            <div class="details-group">
              <p class="text-1">{{item.title}}</p>
              <div class="bast-dynamic-detail-times">
                <div class="details-btn">
                  <span>了解详情</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 查看更多 -->
      <examine-more v-if="moreShow" @examine="examine" :moreLoading='moreLoading'></examine-more>
    </div>
  </div>
</template>
<script>
import { newsListApi } from "../../../../request/api";
import examineMore from '@/components/examineMore'
import SecondTitle from '@/components/SecondTitle'
export default {
  components:{
    SecondTitle,
    examineMore
  },
  data(){
    return{
      moreLoading:false,
      moreShow:true,
      page:1,
      page_size:9,
      activeName: "trends",
      dynamicList:[
        {
          id:'1',
          name:'500R经典版，29999元诚意驾临！',
          img:require('@/assets/img/news/news-icon.jpg'),
          time:'2022-2-25',
        },
        {
          id:'2',
          name:'500R经典版，29999元诚意驾临！',
          img:require('@/assets/img/news/news-icon2.png'),
          time:'2022-2-25',
        },
        {
          id:'3',
          name:'500R经典版，29999元诚意驾临！',
          img:require('@/assets/img/news/news-icon2.png'),
          time:'2022-2-25',
        },
        {
          id:'4',
          name:'500R经典版，29999元诚意驾临！',
          img:require('@/assets/img/news/news-icon.jpg'),
          time:'2022-2-25',
        },
        {
          id:'5',
          name:'500R经典版，29999元诚意驾临！',
          img:require('@/assets/img/news/news-icon2.png'),
          time:'2022-2-25',
        },
        {
          id:'6',
          name:'500R经典版，29999元诚意驾临！',
          img:require('@/assets/img/news/news-icon2.png'),
          time:'2022-2-25',
        },
        {
          id:'7',
          name:'500R经典版，29999元诚意驾临！',
          img:require('@/assets/img/news/news-icon.jpg'),
          time:'2022-2-25',
        },
        {
          id:'8',
          name:'500R经典版，29999元诚意驾临！',
          img:require('@/assets/img/news/news-icon2.png'),
          time:'2022-2-25',
        },
        {
          id:'9',
          name:'500R经典版，29999元诚意驾临！',
          img:require('@/assets/img/news/news-icon2.png'),
          time:'2022-2-25',
        },
      ],
    }
  },
  created(){
    this.newsListApi()
  },
  methods:{
    examine(){
      this.page++
      this.newsListApi()
      this.moreLoading = true
    },
    // 文章数据
    newsListApi(){
      const params = {
        m:'Mobile',
        c:'Article',
        a:'get_all_news_list',
        type:'4',
        lang:'1',
        page:this.page,
        page_size:this.page_size
      }
      newsListApi(params).then(({data})=>{
        this.moreLoading = false
        if (this.page == 1) {
          this.dynamicList = data.datas.info
          if (this.page*this.page_size > data.datas.count) {
              this.moreShow = false
          }
        }else{
          data.datas.info.forEach((item,idx) => {
            if (this.page*this.page_size <= data.datas.count) {
              this.dynamicList.push(item)
            }
            if (this.page*this.page_size > data.datas.count) {
              this.dynamicList.push(item)
              this.moreShow = false
            }
          });
        }
        
      })
    },
    // 跳转详情
    topath(idx,item){
      this.$router.push({
        path:'/news-tidal-details?id=' + item.articel_id,
      })
      localStorage.setItem("content",item.content)
    }
  },
}
</script>
<style lang="scss">
  .dynamic-row{
    // max-width: 1920px;
    width: 100%;
    margin: 0 auto;
  }
.bast-dynamic-detail{
  width: 1300px;
  margin: 30px auto 0px;
  .bast-dynamic-detail-box{
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    .bast-dynamic-detail-item:hover{
      .details-group{
        background-color: #EEC20A;
        box-shadow: 0 0 20px 0 rgba(0, 0, 0, .4);
      }
      .text-1{
        width: 100%;
        color: #000000;
      }
      .details-btn{
        background-color: black !important;
        span{
          color: #EEC20A;
        }
      }
    }
    .upkeep-content-margin{
      margin: 0 27px;
    }
    .bast-dynamic-detail-item{
      cursor: pointer;
      margin-bottom: 20px;
      .item-box{
        display: flex;
        flex-direction: column;
        padding: 15px;
        width: 415px;
        height: 370px;
        .details-group{
          height: 100px;
          padding: 10px;
          transition: 1s;
        }
      }
      .img-box{
        width: 385px;
        height: 230px;
        .bast-dynamic-detail-img{
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      
      .text-1{
        transition: .5s;
        font-size: 17px;
        font-weight: 800;
        line-height: 20px;
        height: 30px;
        width: 240px;
        color: #EEC20A;
      }
      .bast-dynamic-detail-times{
        margin-top: 10px;
        display: flex;
        align-items: center;
        .details-btn{
          position: relative;
          width: 110px;
          height: 34px;
          margin-top: 10px;
          background-color: rgba(0, 0, 0, 0.425);
          display: flex;
          justify-content: center;
          transition: 1s;
          align-items: center;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/news-tidal/trends/trends.vue